import styled from 'styled-components';

export const TextInput = styled.input`
  display: block;
  width: 100%;
  max-width: 680px;
  font-size: 16px;
  margin: ${({margin}) => margin ? margin : '0 auto 16px'};
  padding: 6px 16px;
  border: 2px solid #acacac;
  border-radius: 6px;
  
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type=number] {
    -moz-appearance: textfield;
  }
`;

export const Select = styled.select`
  display: block;
  width: 100%;
  max-width: 680px;
  font-size: 16px;
  margin: 0 auto 16px;
  padding: 6px 16px;
  border: 2px solid #acacac;
  border-radius: 6px;
`;

export const Description = styled.p`
  margin: 0 auto 12px;
  text-align: center;
  max-width: 680px;
`;

const StyledButton = styled.button`
  font-size: 16px;
  padding: 5px 12px;
  min-height: 40px;

  ${({small}) => small === 'true' && `
    font-size: 14px;
    padding: 0px 10px;
    height: 35px;
    min-height: 35px;
  `}

  border-radius: 10px;
  text-shadow: 0 -1px 0 rgba(0,0,0,.12);
  -webkit-box-shadow: 0 2px 0 rgba(0,0,0,.045);
  box-shadow: 0 2px 0 rgba(0,0,0,.045);
`;

export const BtnPrimary = styled(StyledButton)`
  color: #fff;
  background: ${(({theme}) => theme.PRIMARY_COLOR)};
  border-color: ${(({theme}) => theme.PRIMARY_COLOR)};
`;

export const BtnSecondary = styled(StyledButton)`
  color: #fff;
  background: ${(({theme}) => theme.SECONDARY_COLOR)};
  border-color: ${(({theme}) => theme.SECONDARY_COLOR)};
`;

export const BtnGray = styled(StyledButton)`
  color: #fff;
  background: ${(({theme}) => theme.GRAY_BTN)};
  border-color: ${(({theme}) => theme.GRAY_BTN)};
`;
